//#region Libraries
//#endregion
//#region Styles
import {
    Row, 
    Part, 
    TitleSection, 
    Fields 
} from "components/styles";
//#endregion
//#region Components
import HandlerRadio from "components/CustomRadio/CustomRadio";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
import StudentsSection from "./components/StudentsSection/StudentsSection";
import ListSection from "./components/ListSection/ListSection";
//#endregion
//#region Utils
import { handlerKeyPressOnlyNumbers } from "utils/validations";
import { useEffect } from "react";
//#endregion

const publicLoadTypes = [
    { id: 1, text: "Estudiante" },
    { id: 2, text: "Cargar lista (Personalizada)" }
];
const PublicPartForm = ({
    form, changeField, 
    errors, titleListSecion,
    allCampus, errorTexts,
    modalities, as,
    formatFileListSection,
    isAsesoria=false,
    formCampus={}
}) => {
    //#region Functions
    const handlerQuantityVacancyField = value => {
        changeField("quantityVacancy", value, false);
    }
    const changePublicLoad = (field, value, errorValue) => {
        changeField("publicLoad", {
            ...form.publicLoad,
            [field]: value
        }, {
            ...errors.publicLoad, 
            [field]: errorValue
        });
    }
    const changePublicLoadId = id => {
        changePublicLoad("id", id, false);
    }
    const changePublicLoadStudents = (field, value, errorValue) => {
        changePublicLoad("students", {
            ...form.publicLoad.students, 
            [field]: value 
        }, {
            ...errors.publicLoad.students,
            [field]: errorValue
        });
    }
    const changePublicLoadList = (value, errorValue) => {
        changePublicLoad("list", value, errorValue);
    }

    const changePublicLoadStudentsBatch = (fields, errorsFields = {}) => {
        changePublicLoad(
            "students",
            {
                ...form.publicLoad.students,
                ...fields, // merge de todos los campos que mandes
            },
            {
                ...errors.publicLoad.students,
                ...errorsFields, // merge de errores
            }
        );
    };
    //#endregion
    const {  
        publicLoad } = form;
    return (
        <Part>
            <Fields>
                <TitleSection>
                    Público
                </TitleSection>
                {form?.quantityVacancy !== undefined && 
                <Row className="flex-start">
                    <CustomTextInput
                        label="Capacidad de vacantes"
                        placeholder="Número de vacantes"
                        value={form.quantityVacancy}
                        maxLength={5}
                        showCounter
                        helperText="*Solo se permiten números"
                        error={errors.quantityVacancy}
                        errorText="Es necesario agregar el Nº de vacantes."
                        onKeyPress={handlerKeyPressOnlyNumbers}
                        onChange={handlerQuantityVacancyField}/>
                </Row>}
                {form.publicLoad?.id !== undefined &&
                    <Row className="flex-start" 
                    marginBottom="30px" 
                    gap="40px">
                    {<HandlerRadio
                        value={publicLoad.id}
                        onChange={changePublicLoadId}
                        radiosProps={
                            publicLoadTypes.map(({
                                    id, 
                                    text }) => ({
                                value: id, 
                                label: text
                            }))
                        }
                        error={errors.publicLoad.id}
                        errorText="Es necesario seleccionar un público."/>}
                </Row>}
                {publicLoad?.id === undefined || publicLoad.id === 1 
                ? <StudentsSection
                    changeField={changePublicLoadStudents}
                    changeFieldBatch={changePublicLoadStudentsBatch}
                    form={publicLoad.students}
                    formCampus={formCampus}
                    errors={errors.publicLoad.students}
                    modalities={modalities}
                    allCampus={allCampus}
                    isAsesoria={isAsesoria}/>
                : publicLoad.id === 2 
                ? <ListSection
                    title={titleListSecion}
                    changeField={changePublicLoadList}
                    form={publicLoad.list}
                    formatFile={formatFileListSection}
                    errors={errors.publicLoad.list}
                    errorText={errorTexts.publicLoadStudentsFile}/>
                : <NotificationNoContent
                    title={`Aún no has señalado un público para tu ${as}`}
                    description="Selecciona uno para mostrarte las opciones de campus"/>}
            </Fields>
        </Part>
    );
}

export default PublicPartForm;